import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';

import styles from '../../../../constants/styles';
import {
  getCoreMaterialsInUse,
  getPrepregMaterialsInUse,
  getLengthUnit
} from '../../../../reducers';
import { materialPropType } from '../../../../lib/shapes';
import DkDfCharts from './DkDfCharts';
import MaterialsTable from '../../../common/MaterialsTable';

export const MaterialViewer = ({
  classes,
  cores,
  prepregs,
  lengthUnit,
  print 
}) => ( 
  <Paper className={classes.paper}>
    <MaterialsTable materials={cores} header="Cores In Use" />
    {!print && <DkDfCharts materials={cores} lengthUnit={lengthUnit} />}
    <MaterialsTable materials={prepregs} header="Prepregs In Use" />
    {!print && <DkDfCharts materials={prepregs} lengthUnit={lengthUnit} />}
  </Paper>
);

function mapStateToProps(state){
  const cores = getCoreMaterialsInUse(state) || [];
  const prepregs = getPrepregMaterialsInUse(state) || [];
  const lengthUnit = getLengthUnit(state);
  return { cores, prepregs, lengthUnit }
}

MaterialViewer.propTypes = {
  classes:        PropTypes.shape({
    paper: PropTypes.string
  }).isRequired,
  cores:         PropTypes
    .arrayOf(PropTypes.shape(materialPropType))
    .isRequired,
  prepregs:      PropTypes
    .arrayOf(PropTypes.shape(materialPropType))
    .isRequired,
  lengthUnit:    PropTypes.string.isRequired,
  print: PropTypes.bool
};

MaterialViewer.defaultProps = {
  print: undefined,
}

export default withStyles(styles)(
  connect(mapStateToProps)(MaterialViewer)
);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MaterialsViewer/MaterialsViewer.jsx